import { render, staticRenderFns } from "./DossierDownloadDialog.vue?vue&type=template&id=f9ffa80e&scoped=true"
import script from "./DossierDownloadDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DossierDownloadDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DossierDownloadDialog.vue?vue&type=style&index=0&id=f9ffa80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ffa80e",
  null
  
)

export default component.exports